import { useBootstrap } from '../context/BootstrapContext'

export function useTestimonials() {
  const { data, loading } = useBootstrap()
  return { testimonials: data.testimonials, loading }
}
